// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2_7-S","content":"GlobalSearch_content__18HPE"};